export const TOAST_TYPE = {
  SAVED: 'SAVED',
  ALREADY_SAVED: 'ALREADY_SAVED',
  UNDO: 'UNDO',
}

export const TRACKING = {
  IMPRESSION: {
    [TOAST_TYPE.SAVED]: 'added_to_my_favorites',
    [TOAST_TYPE.ALREADY_SAVED]: 'already_in_my_favorites',
  },
  CLICK: 'see_my_favorites',
  ZONE: 'favorites_toast',
}
